import { graphql } from "gatsby"
import { EventInfo } from "components/organisms/webinar/EventInfo"
import { formatWebinars } from "utils/prismic"
import get from "lodash.get"
import SEO from "components/seo"

const extractYouTubeVideoId = (url: string | undefined): string | null => {
  if (!url) return null
  const match = url.match(
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/live\/)([a-zA-Z0-9_-]{11})/
  )
  return match?.[1] ?? null
}

export default function WebinarLivePage({ data }) {
  const webinars = formatWebinars(get(data, "allPrismicWebinar", []))
  const webinar = webinars?.[0]
  if (!webinar) return null

  const displaySections = webinar.sections?.slice(0, 2) ?? []
  const videoId = extractYouTubeVideoId(webinar.url)

  return (
    <>
      <SEO title={webinar.title} />
      <div className="relative overflow-hidden bg-white">
        <div className="relative pb-16 pt-6 sm:pb-24 lg:pb-28">
          <main className="mx-auto mt-20 max-w-4xl space-y-8 px-4 sm:mt-24 sm:px-6 lg:mt-32">
            <div className="text-left">
              <h1 className="m-0 p-0 text-3xl font-bold tracking-tight text-zinc-900 sm:text-5xl">
                {webinar.title}
              </h1>
            </div>
            {videoId ? (
              <iframe
                src={`https://youtube.com/embed/${videoId}`}
                title={`${webinar.title} – Live`}
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="mb-0 aspect-video w-full"
              />
            ) : null}
            <div
              className="rounded-lg bg-zinc-800 p-12"
              id="info"
            >
              <EventInfo webinar={{ ...webinar, sections: displaySections }} />
            </div>
          </main>
        </div>
      </div>
    </>
  )
}

export const pageQuery = graphql`
  query ($locale: String!) {
    allPrismicWebinar(
      sort: { data: { index: ASC } }
      filter: {
        lang: { eq: $locale }
        data: {
          audience: { eq: "general" }
          show_on_pages: { elemMatch: { page: { eq: "/schools/webinar" } } }
        }
      }
    ) {
      nodes {
        id
        lang
        data {
          attendance_type
          language
          show_live_link
          audience
          time
          end
          url {
            url
          }
          tag {
            text
          }
          speakers {
            name
            photo {
              gatsbyImageData(width: 200, placeholder: NONE)
              alt
            }
            speaker_description {
              richText
            }
            speaker_subject {
              richText
            }
          }
          duration
          sections {
            description {
              richText
            }
          }
          summary {
            richText
          }
          title {
            text
          }
          highlights {
            text
          }
        }
      }
    }
  }
`
